<template>
    <!-- 商品删除申请 -->
    <div>
        <content-view>
            <a-spin :spinning="spinning" tip="商品数据加载中...">
                <div class="wrap-container-in materiel-delete-apply">
                    <a-form :form="form" layout="inline">
                        <a-form-item label="仓库选择">
                            <a-select @change="warehouseChange" :options="warehouseOptions" placeholder="请选择" style="width: 200px;" v-decorator="['warehouseId', {rules: [{required: true, message: '请输入'}]}]"></a-select>
                        </a-form-item>
                        <a-divider></a-divider>
                        <div class="mb16">
                            <a-button type="primary" @click="showGoodsPicker">删除商品选择</a-button>
                        </div>
                        <a-table
                        bordered
                        :dataSource="selectedRows"
                        :columns="columns"
                        :scroll="{y: 500}"
                        :pagination="false"
                        :rowKey="record => record.id"
                        class="wrap-table"
                        >
                            <template slot="index" slot-scope="key, row, index">
                                {{index + 1}}
                            </template>
                            <template slot="actions" slot-scope="key,row">
                                <a class="text-primary" @click="batchAddRemove(key)">删除</a>
                            </template>
                        </a-table>
                        <div class="mt16">
                            <a-form-item label="删除原因">
                                <a-textarea style="resize: none; width: 600px;" placeholder="0/200" v-decorator="['remark', {rules: [{ required: true, message: '请输入删除原因'}, { max: 200, message: '字数超出' }, {whitespace: true, message: '删除原因不能为空字符'}]}]" />
                            </a-form-item>
                        </div>
                        <div class="mt16">
                            <a-form-item label="审批人角色">
                                <a-select :options="comfirmRoleList" @change="handleSelectChange" placeholder="请选择" style="width: 200px;" v-decorator="['approvalRoleId', {rules: [{required: true, message: '请输入'}]}]"></a-select>
                            </a-form-item>
                            <a-form-item label="审批人">
                                <a-select :options="memberList" placeholder="请选择" style="width: 200px;" v-decorator="['approvalUserId', {rules: [{required: true, message: '请输入'}]}]"></a-select>
                            </a-form-item>
                        </div>
                    </a-form>
                    <a-divider></a-divider>
                    <div class="text-center">
                        <a-button type="primary" @click="submit" :loading="submitLoading">提交删除申请</a-button>
                    </div>
                </div>
            </a-spin>
            <goods-batch-picker ref="goodsBatchPicker" :warehouseName="currentWarehouse.warehouseName" :goodsList="allGoodsList" :selectedRowKeys="selectedRowKeys" @confirm="selectGoodsModalConfirm"></goods-batch-picker>
        </content-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import goodsBatchPicker from "@/components/modules/storage/goods-batch-picker.component";
    const columns = [
        {
            title: '序号',
            scopedSlots: {customRender: 'index'},
            width: '10%'
        },
        {
            title: '商品编号',
            dataIndex: 'goodsNo',
            width: '20%'
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification',
            width: '15%'
        },
        {
            title: '所在仓库库存',
            dataIndex: 'currentInventory',
            width: '15%'
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions' },
            width: '10%'
        }
    ];
    export default {
        name: 'materielDeleteApply',
        components: {
            goodsBatchPicker
        },
        props: {},
        data() {
            return {
                columns,
                dataSource: [{}],
                warehouseOptions: [],
                visibleBatchAddStorage: false,
                selectedRowKeys: [],
                selectedRows: [],
                allGoodsList: [],
                memberList: [],
                comfirmRoleList: [],
                comfirmMemberList: [],
                submitLoading: false,
                currentWarehouse: {},
                spinning: false
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            warehouseChange() {
                this.selectedRowKeys = [];
                this.selectedRows = [];
                this.allGoodsList = [];
                setTimeout(() => {
                    this.getCategoryAndGoods();
                }, 200);
            },
            /**
             * @showGoodsPicker 打开批量商品选择
             */
            showGoodsPicker() {
                this.$refs.goodsBatchPicker.visible = true;
            },
            /**
             * @selectGoodsModalConfirm 批量商品选择弹窗确定
             */
            selectGoodsModalConfirm({selectedRowKeys, selectedRows}) {
                this.selectedRows.forEach(item => {
                    item.num = undefined;
                });
                this.selectedRowKeys = selectedRowKeys;
                this.selectedRows = selectedRows;
            },
            /**
             * @getCategoryAndGoods 获取分组及分组下所有商品信息
             */
            getCategoryAndGoods() {
                if (!this.shopId) {
                    return false;
                }
                this.currentWarehouse = this.warehouseOptions.find(item => item.id === this.form.getFieldValue('warehouseId'));
                this.spinning = true;
                this.$api.newStorage.selfCategoryAndGoods({
                    body: {
                        shopId: this.shopId,
                        warehouseId: this.currentWarehouse.id 
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.vos.forEach($item => {
                                $item.categoryId = item.id;
                            });
                        });
                        this.allGoodsList = res;
                    }
                    this.spinning = false;
                });
            },
            /**
             * @getWarehouseList 获取门店下仓库列表
             */
            getWarehouseList() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.selfWarehousePage({
                    body: {
                        shopId: this.shopId,
                        pageNum: 1,
                        pageSize: 999999
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        this.warehouseOptions = res.data;
                        if (Boolean(res.data[0])) {
                            this.form.setFieldsValue({
                                warehouseId: res.data[0].id
                            });
                            this.getCategoryAndGoods();
                        }
                    }
                });
            },
            /**
             * @batchAddRemove 批量增加项删除
             */
            batchAddRemove(id) {
                this.selectedRowKeys = this.selectedRowKeys.filter(item => item !== id);
                this.selectedRows = this.selectedRows.filter(item => item.id !== id);
            },
            /**
             * @comfirmRole 审核人职位
             */
            comfirmRole() {
                if(!this.shopId) {
                    return false;
                }
                this.$api.audit.sysRoleRefund({
                }).then(res => {
                    res.forEach(item => {
                        item.label = item.roleName;
                        item.value = item.id;
                    });
                    this.comfirmRoleList = res;
                });
            },
            /**
             * @comfirmMember 审核人 根据职位筛选
             */
            comfirmMember(roleId) {
                if(!this.shopId) {
                    return false;
                }
                this.$api.audit.sysUserRefund({
                    query: {
                        shopId: this.shopId,
                        roleId: roleId
                    }
                }).then(res => {
                    res.forEach(item => {
                        item.label = item.username;
                        item.value = item.id;
                    });
                    this.memberList = res.filter(i => i.id !== this.userInfo.id);
                });
            },
            //切换审核人职位下拉时，改变审核人下拉为当前职位下的人
            handleSelectChange(value) {
                // value.key: 职位ID，value.label: 职位name
                this.form.resetFields(['approvalUserId']);
                this.comfirmMember(value)
            },
            /**
             * @submit 提交出库申请
             */
            submit() {
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    values.applyUserId = this.userInfo.id;
                    values.applyUserName = this.userInfo.name;
                    values.submitter = this.userInfo.account;
                    values.approvalRoleName = this.comfirmRoleList.find(item => item.id === values.approvalRoleId).label;
                    values.approvalUserName = this.comfirmMemberList.find(item => item.id === values.approvalUserId).label;
                    let { selectedRows } = this;
                    let length = selectedRows.length;
                    if (!Boolean(length)) {
                        this.$message.error('请添加商品');
                        return false;
                    }
                    let goodsIds = selectedRows.map(item => item.id);
                    this.submitLoading = true;
                    this.$api.newStorage.selfRemoveGoods({
                        body: {
                            ...values,
                            goodsIds,
                            shopId: this.shopId,
                        }
                    }).then(res => {
                        this.$message.success('操作成功');
                        this.selectedRowKeys = [];
                        this.selectedRows = [];
                        this.form.resetFields();
                        this.submitLoading = false;
                        setTimeout(() => {
                            this.$router.back();
                        }, 300);
                    }).catch(err => {
                        this.submitLoading = false;
                    });
                });
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.comfirmRole();
            this.comfirmMember();
            this.getWarehouseList();
        },
        watch: {
            shopId() {
                this.comfirmRole();
                this.getWarehouseList();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.materiel-delete-apply {
    min-height: 70vh;
    .ant-form-item-label {
        width: 100px;
        text-align: left;
    }
}
</style>
